import { ReactNode } from 'react';
import styled from '@emotion/styled';

interface ItemCardInfoProps {
  children: ReactNode;
}

export const ItemCardInfo = ({ children }: ItemCardInfoProps) => {
  return <ProductInfo>{children}</ProductInfo>;
};

const ProductInfo = styled.div`
  margin: 2px 0 0 0;
  display: flex;
  justify-content: end;
`;
